const genStepsProgressStyle = token => {
    const { antCls, componentCls } = token;
    return {
        [`&${componentCls}-with-progress`]: {
            [`${componentCls}-item`]: {
                paddingTop: token.paddingXXS,
                [`${componentCls}-item-tail`]: {
                    top: `${token.marginXXS}px !important`,
                },
            },
            [`&${componentCls}-horizontal ${componentCls}-item:first-child`]: {
                paddingBottom: token.paddingXXS,
                paddingInlineStart: token.paddingXXS,
            },
            [`${componentCls}-item-icon`]: {
                position: 'relative',
                [`${antCls}-progress`]: {
                    position: 'absolute',
                    insetBlockStart: (token.stepsIconSize - token.stepsProgressSize - token.lineWidth * 2) / 2,
                    insetInlineStart: (token.stepsIconSize - token.stepsProgressSize - token.lineWidth * 2) / 2,
                },
            },
        },
    };
};
export default genStepsProgressStyle;
